module.exports = __webpack_public_path__ + "img/jnhb.58a2367.png";